interface LineIconProps {
  className?: string;
}

export default function LineIcon({ className = '' }: LineIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* 白い吹き出し */}
      <path
        d="M20.5 11C20.5 14.8 17.1 18 12.5 18C11.7 18 10.9 17.9 10.1 17.7L6 20.5L6.8 16.8C4.9 15.5 3.5 13.5 3.5 11C3.5 7.2 6.9 4 11.5 4H12.5C17.1 4 20.5 7.2 20.5 11Z"
        fill="white"
      />
      {/* LINE 文字 */}
      <text
        x="12"
        y="12"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="7"
        fontWeight="bold"
        fontFamily="Arial, Helvetica, sans-serif"
        fill="#06C755"
      >
        LINE
      </text>
    </svg>
  );
}